import React from "react";
import { Link } from "react-router-dom";
import {
  Disc, Dumbbell, Frame, StretchHorizontal, Cog, Wrench, Boxes,
  Footprints, PersonStanding, Bike, Waves, Mountain,
  House, Warehouse, Building2, LayoutGrid,
  Cable, GitFork, Columns2, Activity,
  Grid3x3, SquareStack, Palette, PanelTop, Layers,
  Target, Hand, Bandage, Shield, ShieldCheck, Anchor,
  Circle, Spline, Triangle, HeartPulse, CupSoda,
  ArrowRight,
} from "lucide-react";

export const iconMap = {
  Disc, Dumbbell, Frame, StretchHorizontal, Cog, Wrench, Boxes,
  Footprints, PersonStanding, Bike, Waves, Mountain,
  House, Warehouse, Building2, LayoutGrid,
  Cable, GitFork, Columns2, Activity,
  Grid3x3, SquareStack, Palette, PanelTop, Layers,
  Target, Hand, Bandage, Shield, ShieldCheck, Anchor,
  Circle, Spline, Triangle, HeartPulse, CupSoda,
};

export default function MegaMenu({ link, onNavigate }) {
  if (!link.items) return null;
  const SmartLink = ({ to, className, children }) =>
    to && to.startsWith("/") ? (
      <Link to={to} onClick={onNavigate} className={className}>{children}</Link>
    ) : (
      <a href={to} onClick={onNavigate} className={className}>{children}</a>
    );
  return (
    <div
      className="invisible absolute left-0 right-0 top-full z-50 translate-y-3 opacity-0 transition-all duration-200 ease-out group-hover:visible group-hover:translate-y-0 group-hover:opacity-100"
    >
      <div className="mt-0 overflow-hidden rounded-b-2xl border-t-[3px] border-brand bg-white shadow-2xl">
        <div className="grid grid-cols-12 gap-0">
          {/* Links */}
          <div className="col-span-8 p-6">
            <div className="mb-4 flex items-baseline justify-between">
              <h3 className="font-heading text-sm font-extrabold uppercase tracking-wider text-navy">
                {link.label}
              </h3>
              <SmartLink
                to={link.href}
                className="flex items-center gap-1 text-xs font-bold uppercase tracking-wide text-brand hover:gap-2 transition-all"
              >
                View all <ArrowRight size={13} />
              </SmartLink>
            </div>
            <div className="grid grid-cols-2 gap-2">
              {link.items.map((it) => {
                const Icon = iconMap[it.icon] || Circle;
                return (
                  <SmartLink
                    key={it.label}
                    to={link.href}
                    className="group/item flex items-center gap-3 rounded-xl p-2.5 transition-colors hover:bg-sky"
                  >
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-navy transition-colors group-hover/item:bg-brand group-hover/item:text-white">
                      <Icon size={20} />
                    </span>
                    <span className="min-w-0">
                      <span className="block truncate text-sm font-bold text-navy">{it.label}</span>
                      <span className="block truncate text-xs text-navy/50">{it.desc}</span>
                    </span>
                  </SmartLink>
                );
              })}
            </div>
          </div>
          {/* Featured promo */}
          {link.featured && (
            <SmartLink
              to={link.href}
              className="group/promo relative col-span-4 flex min-h-[260px] items-end overflow-hidden"
            >
              <img
                src={link.featured.image}
                alt={link.featured.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover/promo:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/90 via-navy-dark/40 to-transparent" />
              <div className="relative p-6 text-white">
                <p className="mb-1 text-[11px] font-bold uppercase tracking-[0.2em] text-brand">
                  Featured
                </p>
                <h4 className="font-heading text-xl font-extrabold leading-tight">
                  {link.featured.title}
                </h4>
                <p className="mt-1 text-sm text-white/80">{link.featured.subtitle}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-brand px-5 py-2 text-xs font-bold uppercase tracking-wide text-white transition-all group-hover/promo:gap-2.5">
                  {link.featured.cta} <ArrowRight size={13} />
                </span>
              </div>
            </SmartLink>
          )}
        </div>
      </div>
    </div>
  );
}
